<template>
    <div class="g-content g-autofixheight order-detail not-create">
        <!-- 上传文件弹窗[[ -->
        <acceptance-file-upload ref="acceptanceFileDialog" @change="getDemandItemAttachments"></acceptance-file-upload>
        <!-- 上传文件弹窗]] -->

        <div class="order-message f-clearfix">
            <img
                class="order-detail-header f-fl"
                :src="demandItemInfo.gameLogo"
                width="80"
                height="80"
            >
            <div class="order-detail-intro f-fr">
                <div class="order-name-contain f-clearfix">
                    <span class="order-name f-hide-col-1">{{ demandItemInfo.demandItemName }}</span>
                    <span class="status f-fr">{{ demandItemInfo.statusText }}</span>
                </div>
                <div class="order-lines order-num-line">
                    <div class="order-num">
                        单号:
                        <span class="order-num-detail">{{ demandItemInfo.id }}</span>
                    </div>
                    <div class="budget-all budget-all-r">
                        含税总预算:
                        <div class="budget-all-num">
                            <span class="money-ico">￥</span>
                            {{ $common.toThousandsFilter(demandItemInfo.initialTaxableTotalBudget) }}
                        </div>
                    </div>
                    <div class="budget-all">
                        税后实收:
                        <div class="budget-all-num">
                            <span class="money-ico">￥</span>
                            {{ $common.toThousandsFilter(demandItemInfo.initialTotalBudget) }}
                        </div>
                        <div class="ask-ico">
                            <div class="answer-show">
                                <i class="triangle"></i>
                                <div
                                    class="answer-text"
                                >税费￥ {{ $common.toThousandsFilter(demandItemInfo.initialTax) }} 已由腾讯公司代缴</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="order-lines order-type-line">
                    <div class="order-num">
                        类型:
                        <span class="order-num-detail">{{ demandItemInfo.demandItemTypeText }}</span>
                    </div>
                    <div class="budget-all budget-all-r">
                        含税实际额:
                        <div class="budget-all-num">
                            <span class="money-ico">￥</span>
                            {{ $common.toThousandsFilter(demandItemInfo.taxableTotalBudget) }}
                        </div>
                    </div>
                    <div class="budget-all">
                        税后实收:
                        <div class="budget-all-num">
                            <span class="money-ico">￥</span>
                            {{ $common.toThousandsFilter(demandItemInfo.totalBudget) }}
                        </div>
                        <div class="ask-ico">
                            <div class="answer-show">
                                <i class="triangle"></i>
                                <div
                                    class="answer-text"
                                >税费￥{{ $common.toThousandsFilter(demandItemInfo.tax) }}已由腾讯公司代缴</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="order-lines order-time-line">
                    <div class="order-num">
                        时间:
                        <span
                            class="order-num-detail"
                        >{{ demandItemInfo.startTime }}~{{ demandItemInfo.endTime }}</span>
                    </div>
                    <div class="budget-all">
                        内容形式:
                        <span class="budget-all-num">{{ demandItemInfo.demandTypeText }}</span>
                    </div>
                </div>
                <div class="order-lines order-tips-line">
                    <div class="order-num">
                        说明:
                        <span
                            class="order-num-detail f-hide-col-1"
                        >{{ demandItemInfo.description }}</span>
                    </div>
                    <div class="budget-all">
                        验收要求:
                        <span
                            class="budget-all-num f-hide-col-1"
                            :title="demandItemInfo.approverProve"
                        >{{ demandItemInfo.approverProve }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="commit-task g-autofixheight">
            <!-- 选项卡[[ -->
            <div class="g-tab">
                <a href="javascript:;">
                    <div class="g-tab-item g-tab-item-active">已提交任务</div>
                </a>
            </div>
            <!-- 选项卡]] -->

            <!-- 订单详情(非创作)[[ -->
            <div class="order-detail-status-2">
                <div class="searchs-list">
                    <div class="search f-clearfix">
                        <select-box
                            :selectList="pageConf.attachmentStatusList"
                            :itemTitle="'验收件状态'"
                            :selected.sync="params.status"
                        ></select-box>
                        <!--<div class="list f-fl list-title">-->
                        <!--<p class="name f-fl"><label for="keyword">关键词</label></p>-->
                        <!--<div class="g-select f-fl">-->
                        <!--<input class="input" name="keyword" type="text" placeholder="请输入要搜索的关键词" v-model="params.name">-->
                        <!--</div>-->
                        <!--</div>-->
                        <div class="inquire f-fr">
                            <input
                                class="btn"
                                type="button"
                                value="查询"
                                @click="getDemandItemAttachments"
                            >
                        </div>
                    </div>
                    <ul class="freelance-list">
                        <li
                            class="list f-clearfix"
                            v-for="(attachment,index) in attachmentList"
                            :key="index"
                        >
                            <div class="file-con f-fl">
                                <div class="file-intro-con">
                                    <div class="file-icon"></div>
                                    <div class="file-intro">
                                        <span class="file-name f-hide-col-1">
                                            <a
                                                :href="attachment.attachmentUrl"
                                                target="_blank"
                                            >{{ attachment.attachmentName }}</a>
                                        </span>
                                    </div>
                                </div>
                                <div class="file-author">
                                    <span class="author-name f-hide-col-1">{{ attachment.userName }}</span>1025061249
                                </div>
                                <div class="date f-inlineblock-top">{{ attachment.created }}</div>
                            </div>
                            <!-- 已驳回  一行文本[[ -->
                            <div
                                class="operation reject-one f-fr"
                                v-if="attachment.approvalStatus == 30"
                            >
                                <p class="status">
                                    <span class="color-theme">已驳回</span>
                                    <!--<span class="ico ico-question">-->
                                    <!--<em class="reject-text"><i class="triangle"></i>存在敏感词汇</em>-->
                                    <!--</span>-->
                                </p>
                                <a
                                    class="g-btn"
                                    href="javascript:;"
                                    @click="deleteAttachment(attachment)"
                                >删除</a>
                            </div>
                            <!-- 已驳回  一行文本]] -->

                            <!-- 待审核[[ -->
                            <div
                                class="operation wait-auditing f-fr"
                                v-else-if="attachment.approvalStatus == 10"
                            >
                                <p class="status">
                                    <span class="color-theme">待审核</span>
                                </p>
                                <a
                                    class="g-btn"
                                    href="javascript:;"
                                    @click="deleteAttachment(attachment)"
                                >删除</a>
                            </div>
                            <!-- 待审核]] -->

                            <!-- 已通过[[ -->
                            <div class="operation passed f-fr" v-else>
                                <p class="status">
                                    <span>已通过</span>
                                </p>
                            </div>
                            <!-- 已通过]] -->
                        </li>
                    </ul>

                    <!-- 空数据 start -->
                    <div class="empty f-hide">
                        <img class="empty-img" src="~Assets/img/pages/v4/radar-no-result.png">
                    </div>
                    <!-- 空数据 end -->
                </div>
                <div class="footer-bar">
                    <div class="footer-bar-btn">
                        <div class="g-bottom-btn btn-group">
                            <a class="button f-fr" href="javascript:;" @click="goBack">返回</a>
                            <!--选中状态  为a标签添加类 active -->
                            <a
                                class="button active f-fr"
                                href="javascript:;"
                                v-if="showAcceptanceFileUploadBtn"
                                @click="showUploadDialog"
                            >上传验收件</a>
                            <a
                                class="button active f-fr"
                                href="javascript:;"
                                v-if="showAcceptanceFileUploadBtn"
                                @click="submitCheck"
                                style="margin: 0;"
                            >提交验收</a>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 订单详情(非创作)]] -->

            <!-- 分页[[ -->
            <pagination
                v-if="paginationConf.total >0"
                :total="paginationConf.total"
                :page-size="paginationConf.pageSize"
                @change="pageChange"
                ref="pager"
            ></pagination>
            <!-- 分页]] -->
        </div>
    </div>
</template>
<style lang="scss" scoped>
@import "~Assets/sass/pages/v4/order/order_detail.scss";
.back-btn {
    display: inline-block;
    vertical-align: top;
    width: auto;
    height: 30px;
    margin: 0 10px 0 30px;
    padding: 0 30px;
    border: 1px solid #fd7e28;
    border-radius: 2px;
    line-height: 30px;
    font-size: 14px;
    background: #fd7e28;
    color: #fff;
    cursor: pointer;
}
.status-r {
    display: inline-block;
    font-size: 14px;
}
.budget-all-r {
    width: 200px;
}
</style>

<script>
import selectBox from "Components/v4/dropdown/select_box";
import pagination from "Components/v4/pagination/pagination_v4";
import acceptanceFileUpload from "../acceptance_file_upload";
import {
    PersonDemandAttachments,
    PersonAttachmentDelete,
    PersonDemandItemInfo,
    SubmitPersonDemand
} from "Services/getData.js";
export default {
    name: "v4-order-person-service-detail",
    data() {
        return {
            params: {
                demandItemId: "",
                status: "",
                title: "",
                page: 1,
                pageSize: 10
            },
            pageConf: {
                attachmentStatusList: [
                    {
                        name: "全部",
                        id: ""
                    },
                    {
                        name: "待审核",
                        id: 10
                    },
                    {
                        name: "已通过",
                        id: 20
                    },
                    {
                        name: "已驳回",
                        id: 30
                    }
                ],
                demandTypeList: [
                    {
                        name: "内容创作",
                        id: 10
                    },
                    {
                        name: "劳务服务",
                        id: 20
                    },
                    {
                        name: "福利奖金",
                        id: 30
                    },
                    {
                        name: "补贴补偿",
                        id: 40
                    }
                ],
                contentTypeList: [
                    {
                        name: "全部",
                        id: ""
                    },
                    {
                        name: "图文",
                        id: 0
                    },
                    {
                        name: "视频",
                        id: 1
                    },
                    {
                        name: "小说",
                        id: 50
                    },
                    {
                        name: "图文",
                        id: 60
                    }
                ],
                articleStatusList: [
                    {
                        name: "全部",
                        id: ""
                    },
                    {
                        name: "草稿中",
                        id: 0
                    },
                    {
                        name: "待审核",
                        id: 10
                    },
                    {
                        name: "外团已通过",
                        id: 15
                    },
                    {
                        name: "供应商已通过",
                        id: 18
                    },
                    {
                        name: "已通过",
                        id: 20
                    },
                    {
                        name: "已发布",
                        id: 30
                    },
                    {
                        name: "已驳回",
                        id: 50
                    },
                    {
                        name: "已删除",
                        id: 70
                    }
                ],
                demandItemList: [],
                demandItemMap: {}
            },
            demandItemInfo: {},
            paginationConf: {
                total: 0,
                pageSize: 10
            },
            attachmentList: []
        };
    },
    components: {
        selectBox,
        pagination,
        acceptanceFileUpload
    },
    created() {},
    mounted() {
        this.demandItemInfo.id = this.$route.query.id;
        if (this.demandItemInfo.id > 0) {
            this.getList();
        } else {
            this.$router.history.push({
                name: "v4-order-personal"
            });
        }
    },
    computed: {
        showAcceptanceFileUploadBtn() {
            let showBtnStatus = [3004, 3006];
            if (showBtnStatus.includes(this.demandItemInfo.demandItemStatus)) {
                return true;
            }
            return false;
        }
    },
    methods: {
        submitCheck() {
            this.$confirm("确认提交验收吗？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
                closeOnClickModal: false
            })
                .then(() => {
                    this.doSubmitCheck(this.demandItemInfo.id);
                })
                .catch(() => {});
        },
        async doSubmitCheck(demandItemId) {
            // demandItemId = 123456;
            let res = await SubmitPersonDemand({
                demandItemId
            });
            if (res.status === 200 && res.data.code == 0) {
                if (res.data.code == 0) {
                    this.$alert("提交成功");
                    this.getList();
                }
            }
        },
        goBack() {
            this.$router.go(-1);
        },
        getList() {
            // 根据demandItemType 显示列表：文件、附件
            this.getPersonDemandItemInfo(this.demandItemInfo.id);
            this.getDemandItemAttachments();
        },
        pageChange(param) {
            // this.params.pageSize = param.pageSize; // 发送给接口的字段
            this.params.page = param.pageIndex; // 发送给接口的字段
            this.getDemandItemAttachments();
        },
        deleteAttachment(attachment) {
            this.$confirm("确认删除此验收件")
                .then(() => {
                    this.doDeleteAttachment(attachment.id);
                })
                .catch(e => {
                    console.log(e);
                });
        },
        showUploadDialog() {
            // this.modal.showSubmitFile = true;
            if (!this.demandItemInfo.id) {
                this.$alert("参数错误~");
                return false;
            }
            this.$refs.acceptanceFileDialog.showDialog(this.demandItemInfo.id);
        },
        async getPersonDemandItemInfo(demandItemId) {
            let res = await PersonDemandItemInfo({
                demandItemId
            });
            if (res.status === 200 && res.data.code == 0) {
                if (res.data.code == 0) {
                    let data = res.data.data;
                    let demandTypeList = {};
                    this.pageConf.demandTypeList.filter(type => {
                        demandTypeList[type.id] = type.name;
                    });
                    data.demandTypeText = demandTypeList[data.demandType];
                    this.demandItemInfo = data;
                }
            }
        },
        async getDemandItemAttachments() {
            // demandItemId = 123456;
            this.params.demandItemId = this.demandItemInfo.id;
            let param = this.params;
            let res = await PersonDemandAttachments(param);
            let data = res.data;
            if (res.status === 200 && data) {
                if (res.data.code == 0) {
                    this.attachmentList = data.data.data;
                    this.paginationConf.total = data.data.total;
                }
            }
        },
        async doDeleteAttachment(id) {
            let res = await PersonAttachmentDelete({
                id: id,
                demandItemId: this.demandItemInfo.id
            });
            let data = res.data;
            if (res.status === 200 && data) {
                if (res.data.code == 0) {
                    this.getDemandItemAttachments();
                }
            }
        }
    }
};
</script>

